import React, { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import {
  Card,
  CardBody,
  CardTitle,
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
} from "reactstrap";

//Componentes
import Loading from "../../components/modales/loadingModal";
import DownloadTableButton from "../../components/buttons/downloadTableButton";
import ViewButton from "../../components/buttons/ViewButton";
import ModalExportacionAPE from "./componentes/modalExportacionAPE";
import ModalInformeRequerimientos from "./componentes/modalResumenInforme";
import ModalAsignacionReclutador from "./componentes/modalAsignacionReclutador";
import ListadoAPE from "../../components/lists/ListadoAPE";
import LoadingModalTransparent from "../../components/modales/loadingModalTransparent";

//Redux
import { connect } from "react-redux";

//Funciones
import { userRolValidation } from "../../utils/userValidation/rolValidation";
//GCP Functions
import { functionsHttpsCallable } from "../../utils/FirebaseStorage/firebase";

//API Calls
const listadoSolicitudes = functionsHttpsCallable(
  "ape_listadoSolicitudesReclutamiento"
);
const exportarAPE = functionsHttpsCallable("ape_exportarSolicitud");
const exportarInformeReclutamiento = functionsHttpsCallable(
  "ape_exportarInformeReclutamiento"
);

const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const GestorReclutamiento = (props) => {
  const [userData] = useState(JSON.parse(localStorage.getItem("userData")));
  const [campoBusqueda, setCampoBusqueda] = useState("");
  const [campo, setCampo] = useState("");
  const [userId, setUserId] = useState(parseInt(userData.userId));
  const [listaSolicitudes, setListaSolicitudes] = useState([]);
  const [listaSolicitudesFilter, setListaSolicitudesFilter] = useState([]);
  const [modalInforme, setModalInforme] = useState(false);
  const [modalReclutadores, setModalReclutadores] = useState(false);
  const [modalTransaction, setModalTransaction] = useState(false);
  const [modalVisualizacion, setModalVisualizacion] = useState(false);
  const [solicitudActiva, setSolicitudActiva] = useState();
  const [permisos, setPermisos] = useState({ descarga: false });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let permisosTemp = getPermissions();
    setPermisos(permisosTemp);
    getDataSolicitudes();
    document.title = "Proceso de Selección";
  }, []);

  useEffect(() => {
    handleBusqueda();
  }, [campoBusqueda]);

  const downloadInforme = async (body) => {
    const bodyExp = {
      fechaInicio: body.start,
      fechaFin: body.end,
      codigoEmpresa: parseInt(userData.codigoEmpresa),
    };
    setLoading(true);
    try {
      const downloadLink = await exportarInformeReclutamiento(bodyExp);
      let downloadWindow = window.open(
        downloadLink.data.data,
        "_blank",
        "noopener,noreferrer"
      );
      if (downloadWindow) downloadWindow.opener = null;
      toastSuccess("Descarga exitosa");
      setLoading(false);
    } catch (error) {
      toastSuccess(`Error ${error.message ?? ""}`);
      setLoading(false);
    }
  };

  const getDataSolicitudes = async () => {
    try {
      let body = {
        userId: userId,
        cod_empr: parseInt(userData.codigoEmpresa),
      };
      let dataSolicitudes = await listadoSolicitudes(body);
      setListaSolicitudes(formatListado(dataSolicitudes.data.data));
      setListaSolicitudesFilter(formatListado(dataSolicitudes.data.data));
      setLoading(false);
    } catch (e) {
      console.log("error", e);
    }
  };

  const formatListado = (listado) => {
    const newList = [];
    listado.forEach((item) => {
      newList.push({
        id: item.solicitudId,
        cargo: item.codigoCargo,
        color: item.suspendida ? "warning" : "info",
        estado: item.estadoAPE,
        campo: item.campo,
        creador: item.cedulaCreador,
        responsable: item.codigoActual,
        cliente: item.clienteComercial,
        suspendida: item.suspendida,
        motivioSuspension: item.motivioSuspension,
        name: item.nombreReclutador,
        nombreCandidato: item.nombreCandidato,
        cedulaCandidato: item.cedulaCandidato ? item.cedulaCandidato : "",
        contrato: item.numeroContrato ? item.numeroContrato : "",
      });
    });
    return newList;
  };

  const getColor = (startDate) => {
    let todayDate = new Date(
      new Date(Date.now()).getTime() - 5 * 60 * 60 * 1000
    );
    let newStartDate = new Date(startDate);
    let diference = (todayDate - newStartDate) / (24 * 60 * 60 * 1000);
    if (diference < 10) return "success";
    else if (diference < 20) return "warning";
    else return "danger";
  };
  const getPermissions = () => {
    let rolesDescarga = ["administrador", "reclutador"];
    let rolesInforme = ["administrador"];
    let validacion = {
      descarga: userRolValidation(rolesDescarga, userData),
      informe: userRolValidation(rolesInforme, userData),
    };
    return validacion;
  };

  // const handleBusqueda = () =>{
  //     let solicitudesPropias = listaSolicitudes;
  //     let solicitudesPropiasTemp
  //     if (campoBusqueda !== '' && campoBusqueda !== undefined) {
  //         if (campo === 'cargo') {
  //             solicitudesPropiasTemp = solicitudesPropias.length ? solicitudesPropias.filter(solicitud => solicitud[campo].includes(campoBusqueda.toUpperCase())) : []
  //         }
  //         else if (campo === 'id') {
  //             solicitudesPropiasTemp = solicitudesPropias.length ? solicitudesPropias.filter(solicitud => solicitud[campo].toString().includes(campoBusqueda.toUpperCase())) : []
  //         }
  //         else {
  //             solicitudesPropiasTemp = listaSolicitudes.length ? listaSolicitudes.filter(solicitud => solicitud.creador == userId) : []
  //         }
  //     }
  //     else {
  //         solicitudesPropiasTemp = listaSolicitudes.length ? listaSolicitudes : []
  //     }
  //     setListaSolicitudesFilter(solicitudesPropiasTemp)
  // }

  const handleBusqueda = () => {
    let solicitudesPropiasTemp;
    if (campoBusqueda !== "" && campoBusqueda !== undefined) {
      if (campo) {
        if (listaSolicitudes && listaSolicitudes.length > 0) {
          solicitudesPropiasTemp = listaSolicitudes.filter((solicitud) =>
            solicitud[campo].toString().includes(campoBusqueda.toUpperCase())
          );
        }
      } else {
        solicitudesPropiasTemp = listaSolicitudes;
      }
    } else {
      solicitudesPropiasTemp = listaSolicitudes;
    }
    setListaSolicitudesFilter(solicitudesPropiasTemp);
  };

  const handleAsignacion = () => {
    let tempList = listaSolicitudes;
    const posicion = tempList.findIndex((i) => i.id === solicitudActiva);
    tempList.splice(posicion, 1);
    setListaSolicitudes([...tempList]);
    setListaSolicitudesFilter([...tempList]);
  };

  const downloadSolicitud = async (id) => {
    setModalTransaction(true);
    let body = {
      solicitudId: id,
    };
    try {
      let downloadLink = await exportarAPE(body);
      let downloadWindow = window.open(
        downloadLink.data.data,
        "_blank",
        "noopener,noreferrer"
      );
      if (downloadWindow) downloadWindow.opener = null;
      setModalTransaction(false);
      toastSuccess("Descarga Exitosa!");
    } catch (e) {
      setModalTransaction(false);
      toastError("Hubo un problema con la descarga!");
      console.log("error", e);
    }
  };

  const handleToggleReclutador = (idSolicitud) => {
    setSolicitudActiva(idSolicitud);
    toggleReclutadores();
  };

  const renderListaSolicitudes = () => {
    return (
      <ListadoAPE
        listaSolicitudes={listaSolicitudesFilter}
        linkTo={"/home/procesoseleccion/ape/"}
        proceso={"reclutamiento"}
        enableButton={
          userData.roles.includes("reclutador") ||
          userData.roles.includes("administrador")
        }
        onClickAux={(e) => handleToggleReclutador(e)}
        descargarAPE={(e) => downloadSolicitud(e)}
      />
    );
  };
  const renderModalExportacion = () => {
    return (
      <ModalExportacionAPE
        toggle={() => {
          toggleExportacionInforme();
        }}
        modal={modalInforme}
        // data={dataModal}
        action={(e) => downloadInforme(e)}
      />
    );
  };

  const renderModalReclutadores = () => {
    return (
      <ModalAsignacionReclutador
        toastSuccess={(e) => {
          toastSuccess(e);
        }}
        toastError={(e) => {
          toastError(e);
        }}
        toggle={() => {
          toggleReclutadores();
        }}
        actualizarSolicitudes={() => {
          handleAsignacion();
        }}
        modal={modalReclutadores}
        solicitud={solicitudActiva}
      />
    );
  };

  const toggleVisualizacionInforme = () =>
    setModalVisualizacion((prevModalVisualizacion) => !prevModalVisualizacion);
  const toggleExportacionInforme = () =>
    setModalInforme((prevModalInforme) => !prevModalInforme);
  const toggleReclutadores = () =>
    setModalReclutadores((prevModalReclutadores) => !prevModalReclutadores);

  return loading ? (
    <div className={"loading-area"}>
      <Loading />
    </div>
  ) : (
    <>
      <Toaster />
      <LoadingModalTransparent isOpen={modalTransaction} />
      {renderModalExportacion()}
      {renderModalReclutadores()}
      {/* <ModalInformeRequerimientos
                toggle={() => { toggleVisualizacionInforme() }}
                modal={modalVisualizacion} 
            /> */}
      <Breadcrumb>
        <BreadcrumbItem className="breadcum-display-content" active>
          Resumen de Solicitudes
          <div>
            {permisos.informe ? (
              <ViewButton
                onClick={() => {
                  toggleVisualizacionInforme();
                }}
              />
            ) : null}
            {permisos.descarga ? (
              <DownloadTableButton
                onClick={() => {
                  toggleExportacionInforme();
                }}
              />
            ) : null}
          </div>
        </BreadcrumbItem>
      </Breadcrumb>
      <Card>
        <CardBody>
          <CardTitle tag="h5">Solicitudes</CardTitle>
        </CardBody>
        <CardBody>
          <Row>
            <Col lg="10" md="8" xs="12">
              <TextField
                required
                autoComplete="off"
                key={`key_busqueda`}
                id={`input_busqueda`}
                fullWidth
                label={"Busqueda"}
                onChange={(e) => setCampoBusqueda(e.target.value)}
                defaultValue=""
                margin="normal"
              />
            </Col>
            <Col lg="2" md="4" xs="12">
              <Autocomplete
                required
                margin="dense"
                options={[
                  { label: "Numero APE", value: "id" },
                  { label: "Campo", value: "campo" },
                  { label: "Cargo", value: "cargo" },
                  { label: "Contrato", value: "contrato" },
                  { label: "Cédula Candidato", value: "cedulaCandidato" },
                ]}
                key={`key_Cargo`}
                id={`select_Cargo`}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setCampo(newValue.value);
                  } else {
                    setCampo(undefined);
                    setListaSolicitudesFilter([...listaSolicitudes]);
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} label={"Campo"} margin="normal" />
                )}
                getOptionLabel={(option) => option.label}
                renderOption={(option) => (
                  <React.Fragment>{option.label}</React.Fragment>
                )}
              />
            </Col>
          </Row>
          {renderListaSolicitudes()}
        </CardBody>
      </Card>
    </>
  );
};

export default withAuthenticationRequired(
  connect(mapStateToProps)(GestorReclutamiento),
  {
    onRedirecting: () => <Loading />,
  }
);
